module.exports = __webpack_public_path__ + "components/country-flag/static/gb-ccfdd55fe8e6735309449daf0c947a85.svg";